// extracted by mini-css-extract-plugin
export default {"errorContainer":"error_errorContainer__c0ggC"};